export default __webpack_public_path__ + "static/media/digital_clock.b131ac3b.png";